<template>
	<div class="modal" v-if="showModal">
		<div class="modal-toolbar">
            <span class="modal-controls">
                <span @click="firstPage" title="erste Seite" class="icon-to-start"></span>
                <span @click="prevPage" title="vorherige" class="icon-left-dir "></span>
                <span>{{ page }}/{{ pageCount }}</span>
                <span @click="nextPage" title="nächste" class="icon-right-dir"></span>
                <span @click="lastPage" title="letzte Seite" class="icon-to-end"></span>
            </span>
			<a :href="downloadFile" target="_blank" class="modal-button modal-button--download icon-zurueck"><span class="sr-only">Download</span></a>
			<span class="modal-button modal-button--close icon-plus_x" @click="close"></span>
		</div>

        <pdf class="pdfview" :page="page" :src="pdfData" @num-pages="setPageCount"></pdf>
	</div>
</template>

<script>
	// import api, {ApiDefaults} from "../../utils/api_call";
    import pdf from 'vue-pdf'
	export default {
		name: "FileDownload",
        components:{
		    pdf
        },
		data() {
			return {
				routeFile : this.$route.params.file,
				file : false,
				pdfData : '',
                page:1,
                pageCount : 1
			}
		},
		computed : {
			iframeSrc : function( ) {
				return  this.file;
			},
			showModal : function( ) {
				return ( this.file !== false );
			},
			downloadFile : function( evt ) {
			    return this.file;
				// return this.file.replace('https://','http://');
			},
		},
		props: {
			asOverlay: {
				type : Boolean,
				default : false
			},

		},
		methods: {
		    setPageCount: function(cnt){
                this.pageCount = cnt;
            },
		    firstPage: function(){
		        this.page = 1;
            },
            lastPage: function(){
		        this.page = this.pageCount;
            },
            nextPage: function(){
                this.page = Math.min(this.page +1,this.pageCount);
            },
            prevPage: function(){
                this.page = Math.max(this.page -1,1);
            },
			close : function () {
				this.file = false;
				Events.$emit('modal:close');
			}
		},
		watch : {
			'file' : function( uri ){
				if( uri ) {
				    this.pdfData = uri;
					// api({
					// 	url: uri,
					// 	method: 'GET',
					// 	// headers: headers,
					// 	responseType: 'blob',
					// 	withCredentials : false
					// })
					// .then((response) => {
					// 	this.pdfData = URL.createObjectURL(response.data);
                    //     console.log(URL.createObjectURL(response.data));
                    // })
					// .catch((error) => {
					// 	console.log( error );
					// 	console.log('ERROR   ', error)
					// })
				}
			}
		},

		created() {
			Events.$on( 'modal:open', (url) => this.file = url );

		},
		mounted() {

		}
	}
</script>

<style scoped>
	.modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 500 !important;
		background: rgba( 50,50,50,.8);
		overflow:scroll !important;
		-webkit-overflow-scrolling:touch !important;

	}
	.modal-enter-active {
		animation: modal .3s ease-out forwards;
	}
	.modal-leave-active {
		animation: modal .2s ease-out reverse forwards;
	}
	.modal-toolbar {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 100;
		width: 100%;
		height: 56px;
		padding: 14px 30px;
		background: #000;
		text-align: right;
        display: flex;
        justify-content: space-between;
	}
	.modal-button {
		font-size: 28px;
		vertical-align: middle;
		color: #FFF;
		display: inline-block;
		line-height: 1;
		text-decoration: none;
		margin-left: 10px;
	}
	.modal-button.modal-button--close {
		transform: rotate( 0.125turn );
	}
	.modal-button.modal-button--download {
		transform: rotate( -0.25turn );
	}
    .modal-controls{
        align-self: flex-start;
        margin-right: auto;
    }
    .modal-controls span{
        display: inline-flex;
        width: 24px;
        height: 24px;
        align-items:center;
        justify-content: center;
        margin:0 2px;
        line-height: 24px;
        vertical-align: middle;
    }
    .modal-controls span::before{
        margin:0;
        font-size: 1.8em;
        line-height: 24px;
        vertical-align: middle;
    }
	iframe {
		margin-left: -30px;
		margin-right: -30px;
		width: calc( 100% + 60px );
		max-width: none;
		height: 100%;
	}
	.modal iframe,
	.modal object,
    .modal .pdfview{
		margin: 56px 0 0;
		width: 100%;
		height: calc( 100% - 56px );
		display: block;
	}

	@keyframes modal {
		from {
			opacity: 0;
			transform : translateY( 25% );
		}

		to {
			opacity: 1;
			transform : translateY( 0 );
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/plugins/FileDownload.vue